import { render, staticRenderFns } from "./ProfileCardPopup.vue?vue&type=template&id=bdf711f8&scoped=true&"
import script from "./ProfileCardPopup.vue?vue&type=script&lang=js&"
export * from "./ProfileCardPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCardPopup.vue?vue&type=style&index=0&id=bdf711f8&scoped=true&lang=css&"
import style1 from "./ProfileCardPopup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf711f8",
  null
  
)

export default component.exports